<template>
    <div class="mx-auto">
        <b-row class="mb-0">
            <b>Pesquisar Arquivo por Data:</b>
        </b-row>
        <b-row>
            <b-col md="2">
                <label>
                    Informe a data de início:
                </label>
                <b-input v-model="filtros.dataInicio" id="dataInicio" type="date" placeholder></b-input>
            </b-col>
            <b-col md="2">
                <label>
                    Informe a data de fim:
                </label>
                <b-input v-model="filtros.dataFinal" type="date" placeholder></b-input>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';

    export default {
        props: ['filtros'],
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
            }
        },
        methods: {
            acaoEnter() {
                document.getElementById("btnProxima").click();
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            setTimeout(()=>{
                this.$refs['dataInicio'].$el.focus();
            }, 500);

            window.addEventListener("keypress", function(e) {
                if(e.key == 'Enter') {
                    document.getElementById("btnProxima").click();
                }
            });
        }
    }
</script>